import { SimpleButton } from "./SimpleButton";
import foodicsAiProductLogo from "@/assets/images/foodics-ai-product-logo.png";
import { CHAT_PATH } from "@/constants";

export function ChatButton({ isActive }: { isActive: boolean }) {
  return (
    <div id="chat-button">
      <SimpleButton
        icon="Conversation"
        label="AI Agent"
        imageSrc={foodicsAiProductLogo}
        imageClassName="h-5 w-auto object-contain"
        href={CHAT_PATH}
        isActive={isActive}
      />
    </div>
  );
}
